import { win } from "./namespaces";
import { raise } from "./errors";
import type { AnyFunction } from "../lib/event/index.js";


/**
 *
 */
export type AsExportedFunction<N> = {
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  <K extends keyof N & string>(
    key: K,
  ): N[K] extends AnyFunction ? N[K] : { error: `Namespace path does not point to a function` };
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useSyncExporter: <N>(getNamespace: (win: Window) => N) => AsExportedFunction<N> =
  (getNamespace) =>
  /**
 *
 *
 *
 *
 *
 */
  /*                      */
  (
    key,
    namespace: ReturnType<typeof getNamespace> | undefined = getNamespace(win) as
      ReturnType<typeof getNamespace> | undefined,
    memberFunction: AnyFunction | undefined = typeof namespace?.[key] === "function"
      ? (namespace[key] as AnyFunction)
      : undefined,
  ) =>
    /*                      */ ((...args: unknown[]): unknown => {
      /*                                                   */
      if (memberFunction) return memberFunction(...args);

      /*                                                                                                                         */
      /*                                                                                              */
      namespace ??=
        getNamespace(window) ??
        raise(`Could not access parent namespace for key "${String(key)}".`);

      /*                                                                                         */
      if (typeof namespace[key] !== "function") {
        raise(`Namespace path "${String(key)}" does not point to a function.`);
      }

      /*                                                                                       */
      memberFunction = namespace[key] as AnyFunction;
      return memberFunction(...args);
    }) as never; /*                                       */


